import { render, staticRenderFns } from "./ListCompanies.vue?vue&type=template&id=573274ae&scoped=true"
import script from "./ListCompanies.vue?vue&type=script&lang=ts"
export * from "./ListCompanies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573274ae",
  null
  
)

export default component.exports